// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePoolJoinBody = {
  code?: string;
  joinCode?: string;
  requestId?: string | null;
  targetPoolId?: string;
};

export type typePoolJoinOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    poolId: string;
    membershipStatus: "pending" | "active";
    isPendingApproval: boolean;
  };
};

export type typePoolJoinOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolJoinOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolJoinOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPoolJoinBody = {
  type: "object",
  properties: {
    code: { type: "string", maxLength: 3000, minLength: 1 },
    joinCode: { type: "string", maxLength: 3000, minLength: 1 },
    requestId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    targetPoolId: { type: "string", maxLength: 3000, minLength: 1 },
  },
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPoolJoin(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPoolJoinBody);
  }

  return async function postPoolJoin(
    payload: typePoolJoinBody,
  ): Promise<typePoolJoinOutput200 | typePoolJoinOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPoolJoin" failed before calling the network. #29a70b78b1a1`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#29a70b78b1a1" },
        },
        data: null,
      } as typePoolJoinOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pool/join`,
      httpMethod: "POST",
      options,
    })) as typePoolJoinOutput200 | typePoolJoinOutput400;
  };
}
